/**
 * ! This component/file or some other components/files that use this component/file is being shared in one or more micro-frontend.
 * ! Please be careful when editing this component. Make sure to run "yarn build:dev" and check if the "build/@types/index.d.ts" file
 * ! is being generated or not without any errors.
 */
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { STYLE } from '../../../../../constants/style';
import { toREM } from '../../../../../utils/generalUtils';

export const useStyles = makeStyles(theme =>
  createStyles({
    loginIcons: {
      '& svg': {
        fill: STYLE.COLOR.INACTIVE,
      },
    },
    loginLabels: {
      '&.MuiTypography-root': {
        fontSize: `${toREM(STYLE.FONT.SIZE.PARAGRAPH)}`,
      },

      '& .MuiTextField-root': {
        marginTop: '4px',
      },
    },
    textField: {
      '&.MuiTextField-root': {
        margin: theme.spacing(1, 0, 1, 0),
        backgroundColor: STYLE.COLOR.OCTONARY,
      },
      '&.MuiInputBase-input': {
        height: '0.85em',
        lineHeight: '27px',
        padding: '0 !important',

        '&::placeholder': {
          color: STYLE.COLOR.INPUT_PLACEHOLDER,
        },
      },

      '&.MuiInputBase-input:disabled': {
        cursor: 'not-allowed',
        color: `${STYLE.COLOR.INPUT_TEXT_DISABLED} !important`,
        '&::placeholder': {
          color: `${STYLE.COLOR.INPUT_PLACEHOLDER_DISABLED} !important`,
          opacity: 1,
        },
      },

      '&.MuiOutlinedInput-input': {
        fontSize: `${toREM(STYLE.FONT.SIZE.PARAGRAPH_BIG)}`,
        fontWeight: 500,
        position: 'relative',
        top: `${toREM(2)}`,
      },

      '&.Mui-focused': {
        '&.MuiSvgIcon-root': {
          fill: STYLE.COLOR.SECONDARY_DARKER,
        },
      },
    },
    formControl: {
      width: '100%',

      '& .MuiTypography-root': {
        fontSize: `${toREM(STYLE.FONT.SIZE.PARAGRAPH)}`,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },

      '& .MuiOutlinedInput-root': {
        lineHeight: '27px',
        fontWeight: 600,
      },
      '& .MuiOutlinedInput-input': {
        backgroundColor: STYLE.COLOR.INPUT_BACKGROUND,
        fontWeight: 600,
      },
      '& .MuiOutlinedInput-notchedOutline': {
        borderWidth: '2px',
        borderColor: STYLE.COLOR.INPUT_BORDER,
      },
      '& .MuiOutlinedInput-input:disabled': {
        cursor: 'not-allowed',
        color: `${STYLE.COLOR.INPUT_TEXT_DISABLED} !important`,
        '&::placeholder': {
          color: `${STYLE.COLOR.INPUT_PLACEHOLDER_DISABLED} !important`,
          opacity: 1,
        },
      },
      '& .MuiOutlinedInput-root.Mui-focused': {
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: `${STYLE.COLOR.INPUT_BORDER_FOCUS}`,
          borderWidth: '2px',
        },
      },
      '& .MuiOutlinedInput-root:hover': {
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: `${STYLE.COLOR.INPUT_BORDER_HOVER}`,
          borderWidth: '2px',
        },
      },
      '& .Mui-disabled.MuiOutlinedInput-root': {
        '& .MuiOutlinedInput-notchedOutline': {
          borderWidth: '2px',
          borderColor: `${STYLE.COLOR.INPUT_BORDER_DISABLED} !important`,
        },
      },
      '& .Mui-error': {
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: `${STYLE.COLOR.INPUT_BORDER_ERROR} !important`,
          borderWidth: '2px',
        },
      },
    },
    requiredMark: {
      color: STYLE.COLOR.ERROR,
    },
    skippableMark: {
      color: '#ffa726',
    },
  })
);
